import React from "react";
import { bool, string } from "prop-types";
import cx from "classnames";

const propTypes = {
  alt: string.isRequired,
  circle: bool,
  fluid: bool,
  rounded: bool,
  src: string.isRequired,
};

const CLASS_ROOT = "img";

const Image = ({ className, fluid, rounded, circle, src, alt, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--fluid`]: fluid,
      [`${CLASS_ROOT}--rounded`]: rounded,
      [`${CLASS_ROOT}--circle`]: circle,
    },
    className
  );

  return <img className={classes} src={src} alt={alt} {...other} />;
};

Image.displayName = "Image";
Image.propTypes = propTypes;

export default Image;
